import React from 'react'
import Image from 'next/image'
import { FiCalendar } from '@react-icons/all-files/fi/FiCalendar'
import Action from '../primitives/Action'
import Container from '../foundations/Container'
import { MEDIA_POLICY_KEYS, resolveMediaPolicy } from '../primitives/mediaPolicy'
import useRevealOnce from '../motion/useRevealOnce'
import motionStyles from '../motion/MotionReveal.module.scss'
import styles from './BuilderPromoV2.module.scss'

const builderMediaPolicy = resolveMediaPolicy({ policy: MEDIA_POLICY_KEYS.SECTION_SPLIT })

const BuilderPromoV2 = ({
  image,
  intro,
  onStart,
  question,
  steps,
  motionProfile = 'static',
}) => {
  const shouldAnimate = motionProfile === 'homepage'
  const { entered, ref } = useRevealOnce({ enabled: shouldAnimate })

  return (
    <section className={styles.section} aria-labelledby='event-builder-heading'>
      <Container width='wide' className={styles.container}>
        <p className={styles.question}>{question}</p>

        <div className={styles.layout} ref={ref}>
          <div className={styles.copy}>
            <h2 id='event-builder-heading'>{intro}</h2>

            <ol className={`${styles.steps} ${shouldAnimate ? motionStyles.stagger : ''} ${entered ? motionStyles.entered : ''}`.trim()}>
              {steps.map((step, index) => (
                <li key={index}>
                  <span className={styles.stepNumber}>{index + 1}</span>
                  <p>{step}</p>
                </li>
              ))}
            </ol>

            <Action
              icon={FiCalendar}
              onClick={onStart}
              size='large'
              className={styles.action}
            >
              Build Your Event
            </Action>
          </div>

          <div className={`${styles.visual} ${shouldAnimate ? motionStyles.reveal : ''} ${shouldAnimate ? motionStyles.delay : ''} ${entered ? motionStyles.entered : ''}`.trim()}>
            <div className={styles.imageFrame}>
              <Image
                src={image}
                alt='Miami Sound Rental Event Builder interface shown on a laptop'
                quality={builderMediaPolicy.quality}
                sizes={builderMediaPolicy.sizes}
              />
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default BuilderPromoV2
